const toolTipData = [
  {
    id: "date",
    text: "Select Date."
  },
  {
    id: "locationName",
    text: "Select Location to Get the Users Attendance."
  },
  {
    id: "onOffLocation",
    text: "Select On or Off to see Location Details."
  },
  {
    id: "Filter",
    text: "Search by User-id, Aadhar-Card, Full Nam."
  }
];

const tableHeaderData = [
  {
    label: "Full Name",
    place: "left",
    type: "workerFullName",
    toolTipText: "Click for Full Name Sorting"
  },
  {
    label: "User Id",
    place: "left",
    type: "workerId",
    toolTipText: "Click for E-ID Sorting"
  },
  {
    label: "Shift",
    place: "left",
    type: "shiftCode",
    toolTipText: "Click for shift Sorting"
  },

  {
    label: "In-Time",
    place: "left",
    type: "inTime",
    toolTipText: "Click for In-Time Sorting"
  },
  {
    label: "Out-Time",
    place: "left",
    type: "outTime",
    toolTipText: "Click for Out-Time Sorting"
  }
];

const selectOptions = [
  {
    label: "Location",
    value: "Location"
  },
  {
    label: "Department",
    value: "workerDepartment"
  },
  {
    label: "Designation",
    value: "workerDesignation"
  },
  {
    label: "Regularized Date",
    value: "regularizedDate"
  },
  {
    label: "Regularized Remark",
    value: "regularizedRemark"
  },
  {
    label: "Late",
    value: "lateTime"
  },
  {
    label: "Over-Time",
    value: "overTime"
  },
  {
    label: "In-Loc",
    value: "inLocation"
  },
  {
    label: "Out-Loc",
    value: "outLocation"
  },
  {
    label: "In-Category",
    value: "inCategory"
  },
  {
    label: "Out-Category",
    value: "outCategory"
  },
  {
    label: "In-Shift-Type",
    value: "inShiftType"
  },
  {
    label: "Out-Shift-Type",
    value: "outShiftType"
  },
  {
    label: "Aadhar Card Number",
    value: "workerAadharCardNumber"
  },
  {
    label: "Employee Type",
    value: "workerType"
  },
  {
    label: "Detection Image",
    value: "detectionImages"
  }
];

export { toolTipData, tableHeaderData, selectOptions };
